import React from "react";
import { SEO } from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Categories } from "@/components/site/Categories";
import { Supply } from "@/components/site/Supply";
import { Gallery } from "@/components/site/Gallery";
import { Offers } from "@/components/site/Offers";
import { InquiryForm, PartnershipForm } from "@/components/site/Forms";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  const { t, lang } = useLang();
  return (
    <main data-testid="home-page">
      <SEO title={t.seo.home.title} description={t.seo.home.description} lang={lang} />
      <Hero />
      <BrandMarquee />
      <Manifesto />
      <Categories />
      <Supply />
      <Gallery />
      <Offers />
      <InquiryForm />
      <PartnershipForm />
      <Contact />
    </main>
  );
}
